import ListSelectDisplay from './ListSelectDisplay';
import ListSelectEditor from './ListSelectEditor';
import ListSelectDesigner from './ListSelectDesigner';

const ListSelect = {
  // components that do the actual work
  designer: ListSelectDesigner,
  display: ListSelectDisplay,
  editor: ListSelectEditor,
};

export default ListSelect;



// WEBPACK FOOTER //
// ./src/components/types/ListSelect/ListSelect.js